var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgListDescending16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.03821,
    y: 2.62502,
    width: 9.50245,
    height: 1.75,
    rx: 0.875,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.03809,
    y: 7.12502,
    width: 9.50245,
    height: 1.75,
    rx: 0.875,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.03809,
    y: 11.625,
    width: 9.50245,
    height: 1.75,
    rx: 0.875,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.13476 3.23681V10.1883H0.865578C0.525683 10.1883 0.336549 10.5813 0.548605 10.847L2.67507 13.5107C2.83744 13.7141 3.14664 13.7141 3.30901 13.5107L5.43548 10.847C5.64754 10.5813 5.4584 10.1883 5.11851 10.1883H3.93476V3.23681C3.93476 2.73975 3.53182 2.33681 3.03476 2.33681C2.5377 2.33681 2.13476 2.73975 2.13476 3.23681Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgListDescending16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;